import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

Vue.config.productionTip = false

Vue.prototype.$axios = axios

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$axios.defaults.headers.common['Content-Type'] = 'application/json'
  Vue.prototype.$axios.defaults.headers.common['GSDAuthorization'] = token
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
